// StorageService.ts

export const clearSessionDetails = () => {
  try {
    localStorage.clear();
    sessionStorage.clear();
  } catch (error) {
    console.error('Error clearing localStorage:', error);
  }
};

export const getDataFromLocalStorage = (key: string): any => {
  const storedData = localStorage.getItem(key);
  if (storedData) {
    return JSON.parse(storedData);
  }
  return null;
};

export const getRtcToken = (): string | null => {
  return localStorage.getItem('token');
}

export const setRtcToken = (token: string): void => {
  localStorage.setItem('token', token);
};

export const setSessionRerdingId = (recordingId: string): void => {
  localStorage.setItem('recordingId', recordingId)
}

export const getSessionRecordingId = (): string | null => {
  return localStorage.getItem('recordingId')
}

export const clearSessionRecordingId = (): void => {
  localStorage.removeItem('recordingId');
};